<div
  *transloco="let t; read: 'widgets.predictive'"
  class="predictive-widget-datepickers__container"
  [ngClass]="validationFailed ? 'notValid' : ''"
  [matTooltip]="validationTooltip"
>
  <div class="predictive-widget-datepicker-container">
    <label
      class="predictive-widget-datepicker-label"
      for="predictive-widget-datepickers-trend-dropdown"
      >{{ t('previous') }}:</label
    >

    <xi-calendar
      id="predictive-widget-datepickers-trend-dropdown"
      [data]="predictiveWidgetDateCalendarTrend"
      [minDate]="prevDateMin"
      [maxDate]="prevDateMax"
      [placeholder]="t('choose-time-period')"
      [popoutView]="true"
      [class.disabled-pointer]="dashboard.locked"
      (onValueChange)="onPredictiveWidgetDateChange($event, 'trend')"
    ></xi-calendar>
  </div>

  <div class="predictive-widget-datepicker-container">
    <label
      class="predictive-widget-datepicker-label"
      for="predictive-widget-datepickers-current-dropdown"
      >{{ t('current') }}:</label
    >

    <xi-calendar
      id="predictive-widget-datepickers-current-dropdown"
      [data]="predictiveWidgetDateCalendarCurrent"
      [minDate]="currDateMin"
      [maxDate]="currDateMax"
      [placeholder]="t('choose-time-period')"
      [popoutView]="true"
      [class.disabled-pointer]="dashboard.locked"
      (onValueChange)="onPredictiveWidgetDateChange($event, 'current')"
    ></xi-calendar>
  </div>
</div>
